import { ComponentPropsWithoutRef } from 'react';
import { Separator } from '@givebutter/primitives/separator';
import { twMerge } from 'tailwind-merge';

const SelectListItemSeparator = (props: ComponentPropsWithoutRef<'div'>) => {
    const { className = '' } = props;

    return (
        <Separator
            className={twMerge(
                '!my-2 -mx-1.5 list-item !w-auto bg-gray-200 first:hidden',
                className,
            )}
        />
    );
};

export { SelectListItemSeparator };
